// src/Components/FullPageLoader.js
import React from "react";
import "../css/loader.css"; // Make sure this path matches your structure

const FullPageLoader = () => {
  return (
    <div className="full-page-loader">
      <div className="dots-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default FullPageLoader;
